import { Box, Stack } from "@chakra-ui/react";
import { Dispatch, FC, SetStateAction, useState } from "react";
import { useParams } from "react-router-dom";
import { FieldValues } from "react-hook-form";

import { Toast } from "../../../components/atom/Toast/Toast";
import SelectComponent from "../../../components/molecule/Select/SelectComponent";
import InputFieldComponent from "../../../components/molecule/InputField/InputFieldComponent";
import ModalComponent from "../../../components/organism/Modal/ModalComponent";
import ModalFooterComponent from "../../../components/organism/Modal/ModalFooterComponent";
import { handleSubmitItem } from "../controller/SubmitAuxiliares";
import { handleDeleteItem } from "../controller/DaleteAuxiliares";
import { auxiliaresLookUps } from "../data/AuxiliaresLookUps";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";
import { AuthUser } from "../../../types/User/AuthUser";

interface ModalAuxiliaresProps {
  setDataTable: Dispatch<SetStateAction<any[]>>;
  setOriginalDataTable: Dispatch<SetStateAction<any[]>>;
  ParentName?: string;
  idItem?: string;
  errors: any;
  handleSubmit: any;
  control: any;
  placeholderName?: string;
  parentData?: any;
  modalConfig: ModalConfig;
  user: AuthUser;
}

const ModalAuxiliares: FC<ModalAuxiliaresProps> = ({
  setDataTable,
  setOriginalDataTable,
  ParentName,
  idItem,
  errors,
  handleSubmit,
  control,
  parentData,
  modalConfig,
  user,
}) => {
  const { isOpen, title = "", buttonTitle, closeModal } = modalConfig;
  const [isLoaded, setIsLoaded] = useState(true);
  const { addToast } = Toast();
  const { table } = useParams<{ table: string }>();
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const onSubmit = async (data: FieldValues) => {
    setIsLoaded(false);
    await handleSubmitItem(
      data,
      table || "",
      buttonTitle,
      idItem,
      setDataTable,
      setOriginalDataTable,
      addToast,
      closeModal,
    );
    setIsLoaded(true);
  };

  const handleDelete = () => {
    if (idItem && table) {
      handleDeleteItem(
        idItem,
        table,
        setDataTable,
        setOriginalDataTable,
        addToast,
        setIsAlertOpen,
        closeModal,
        setIsLoaded,
      );
    }
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={closeModal}
      title={title}
      isAlertOpen={isAlertOpen}
      setIsAlertOpen={setIsAlertOpen}
      handleDelete={
        user?.permissions && user.permissions.includes("ManageLookups")
          ? handleDelete
          : undefined
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={4} pb="2">
          <Box>
            <InputFieldComponent
              label="Código"
              name="code"
              type="text"
              register={control.register}
              errors={errors}
              isRequired
            />
          </Box>

          <Box>
            <InputFieldComponent
              label="Nome"
              name="name"
              type="text"
              register={control.register}
              errors={errors}
              isRequired
            />
          </Box>

          {table && auxiliaresLookUps[parseInt(table, 10) - 1]?.getParent && (
            <Box>
              <SelectComponent
                errors={errors}
                fieldNameObject="province"
                options={parentData}
                fieldName={ParentName}
                isRequired={true}
                control={control}
              />
            </Box>
          )}
        </Stack>
        <ModalFooterComponent
          setIsAlertOpen={setIsAlertOpen}
          setIsOpen={closeModal}
          buttonTitle={buttonTitle}
          deleteEnabled={
            user?.permissions
              ? user.permissions.includes("ManageLookups")
              : false
          }
          isLoaded={isLoaded}
        />
      </form>
    </ModalComponent>
  );
};

export default ModalAuxiliares;
